export function addScrollListener(fn: EventListenerOrEventListenerObject) {
  const el = window.document.getElementById('__pageContainer__') || window
  el.addEventListener('scroll', fn)
}

export function removeScrollListener(fn: EventListenerOrEventListenerObject) {
  const el = window.document.getElementById('__pageContainer__') || window
  el.removeEventListener('scroll', fn)
}
